__turbopack_context__.v({
  "actions": "ZtSB3q_actions",
  "control": "ZtSB3q_control",
  "error": "ZtSB3q_error",
  "expired": "ZtSB3q_expired",
  "expiredIcon": "ZtSB3q_expiredIcon",
  "heading": "ZtSB3q_heading",
  "hint": "ZtSB3q_hint",
  "login": "ZtSB3q_login",
  "note": "ZtSB3q_note",
  "queueLink": "ZtSB3q_queueLink",
  "retractButton": "ZtSB3q_retractButton",
  "status": "ZtSB3q_status",
  "voteButton": "ZtSB3q_voteButton",
});
